import axios, { AxiosInstance, AxiosError } from "axios"
import config from "config/config"

import { v4 as uuid } from "uuid"
import { isBadRequest, isUnauthorized } from "./utils"

const CORRELATION_ID_HEADER = "Correlation-Id"
const APPLICATION_JSON = "application/json"
const AUTH_ERROR_MESSAGE_BY_ERROR_CODE: { [index: string]: string } = {
	"/problems/unauthorized":
		"phronesis.login.form.error.password.username.incorrect",
	"/problems/user-disabled": "phronesis.login.form.error.disabled.account",
	"/problems/user-blocked": "phronesis.login.form.error.blocked.account",
}

const createAxiosInstance = (): AxiosInstance => {
	const { url, timeout } = config.phronesis_auth_api

	const instance = axios.create({
		baseURL: url,
		timeout: timeout.timeout,
		withCredentials: true,
	})

	instance.interceptors.request.use((requestConfig) => {
		requestConfig.headers[CORRELATION_ID_HEADER] = uuid()
		return requestConfig
	})

	instance.interceptors.response.use(
		(response) => response,
		(error) => handleAuthenticationError(error)
	)

	return instance
}

const createdInstance = createAxiosInstance()

export const HttpPostRequest = <Response, Body>(
	endpoint: string,
	body: Body
): Promise<Response> =>
	createdInstance
		.post(endpoint, JSON.stringify(body), {
			headers: {
				"Content-Type": APPLICATION_JSON,
			},
		})
		.then((response) => {
			return response.data
		})

// eslint-disable-next-line complexity
const handleAuthenticationError = (error: any): Promise<never> => {
	if (isBadRequest(error)) {
		return handleBadRequest(error)
	}

	if (isUnauthorized(error)) {
		getUnauthorizedMessageBasedOnErrorCode(error?.response?.data?.errCode)
		return Promise.reject(
			new Error(
				getUnauthorizedMessageBasedOnErrorCode(error?.response?.data?.errCode)
			)
		)
	}

	return Promise.reject(new Error("unknown error"))
}

const handleBadRequest = (error: any | AxiosError) => {
	if (!error) {
		return Promise.reject(new Error("unknown error"))
	}
	const message = error.response?.data
	return Promise.reject(new Error(message))
}

const getUnauthorizedMessageBasedOnErrorCode = (errCode: string): string => {
	return (
		AUTH_ERROR_MESSAGE_BY_ERROR_CODE[errCode] ||
		"phronesis.login.form.error.password.username.incorrect"
	)
}
